// Facts the deployment page derives from a deployment's network and runs (spec 11 6.15.15).
import type { Deployment, Run } from '../../api/types';
import { isTerminalRunStatus } from '../../api/types';

/** The deployment's latest connect or detach run (its runs list includes its network attachment runs). */
export function attachmentRun(runs: readonly Run[], deploymentId: string, mode: 'connect' | 'detach') {
  return runs.find(
    (r) => r.scope === 'attachment' && r.attachmentMode === mode && r.attachmentDeploymentId === deploymentId,
  );
}

/** After a detach whose system apply failed with `NETWORK_DETACH_UNEXPECTED_CHANGE`, until an apply succeeds. */
export function nameResolutionOff(runs: readonly Run[]): boolean {
  const apply = runs.find((r) => r.kind === 'apply' && !r.networkId && isTerminalRunStatus(r.status));
  return apply?.status === 'failed' && apply.error?.code === 'NETWORK_DETACH_UNEXPECTED_CHANGE';
}

/**
 * The interruption banner's facts: while an attachment is `spoke-ready`, `connecting` or `failed` and the last successful
 * apply completed after its `connectedAt` (or it was never connected), since when, and the connect run.
 */
export function interruption(deployment: Deployment, runs: readonly Run[]) {
  const network = deployment.network;
  const applied = deployment.lastSuccessfulApply?.completedAt;
  if (!network || network.mode !== 'attached' || !applied) return null;
  const interrupted = network.attachments.some(
    (a) =>
      (a.state === 'spoke-ready' || a.state === 'connecting' || a.state === 'failed') &&
      (!a.connectedAt || Date.parse(applied) > Date.parse(a.connectedAt)),
  );
  if (!interrupted) return null;
  return { since: applied, run: attachmentRun(runs, deployment.id, 'connect') ?? null };
}
